import {SourcingVehicleResponseBody} from '@dms/api/core';

import {BlacklistFlag} from './BlacklistFlag';
import {HitlistFlag} from './HitlistFlag';

interface HitlistBlacklistFlagProps {
  sourcingVehicle?: SourcingVehicleResponseBody | null;
}

export function HitlistBlacklistFlag(props: HitlistBlacklistFlagProps) {
  if (props.sourcingVehicle?.isHitlist === props.sourcingVehicle?.isBlacklist) {
    return null;
  }

  return props.sourcingVehicle?.isHitlist ? <HitlistFlag /> : <BlacklistFlag />;
}
